import { useSnackbarContext } from "@repo/contexts/SnackbarContext";
import { useTranslations } from "next-intl";

const useSnackbarHandler = () => {
  const { setSnackbar } = useSnackbarContext();
  const t = useTranslations("Common");
  const showSnackbar = (response, fallbackMessage = null) => {
    setSnackbar({
      open: true,
      message:
        response?.message ||
        response?.errorMessage ||
        fallbackMessage ||
        t("Something_Went_Wrong_Please_Try_Again"),
      type: response?.success ? "success" : "error",
    });
  };
  return { showSnackbar };
};

export default useSnackbarHandler;
